import { Link } from "react-router-dom";

const css = `
.ffh-foot{background:#0B2E52;color:#B9CCE0;padding:56px 0;font-size:.9rem;line-height:1.55}
.ffh-foot *{box-sizing:border-box}
.ffh-foot .ffh-foot-wrap{max-width:1160px;margin:0 auto;padding-left:20px;padding-right:20px}
.ffh-foot .ffh-foot-grid{display:grid;grid-template-columns:minmax(0,1.4fr) repeat(3,minmax(0,1fr));gap:28px}
.ffh-foot .ffh-foot-stack{display:grid;gap:14px;align-content:start}
.ffh-foot .logo{margin:0;display:inline-block;justify-self:start;background:none;padding:0}
.ffh-foot .logo a{display:inline-flex;align-items:center}
.ffh-foot .logo img{display:block;max-height:48px;width:auto}
.ffh-foot p{margin:0;color:inherit;line-height:1.55}
.ffh-foot h4{line-height:1.3;color:#fff;font-size:.75rem;letter-spacing:.12em;text-transform:uppercase;margin:0 0 10px;font-weight:700}
.ffh-foot ul{list-style:none;margin:0;padding:0;display:grid;gap:6px;align-content:start}
.ffh-foot li{margin:0;padding:0;list-style:none;line-height:1.5;display:block}
.ffh-foot a{display:inline;margin:0;padding:0;color:#DCE8F4;text-decoration:none;line-height:inherit;background:none;border:0}
.ffh-foot .ffh-foot-legal p{display:block;margin:0;line-height:1.55}
.ffh-foot .ffh-foot-legal p a{display:inline;white-space:nowrap}
.ffh-foot a:hover{text-decoration:underline}
.ffh-foot .ffh-foot-legal{margin-top:36px;padding-top:20px;border-top:1px solid rgba(255,255,255,.14);display:grid;gap:8px;font-size:.75rem;color:#9DB3CB}
@media (max-width:860px){.ffh-foot .ffh-foot-grid{grid-template-columns:1fr 1fr}}
@media (max-width:520px){.ffh-foot .ffh-foot-grid{grid-template-columns:1fr}}
`;

export default function Footer() {
  return (
    <footer className="ffh-foot">
      <style>{css}</style>
      <div className="ffh-foot-wrap">
        <div className="ffh-foot-grid">
          <div className="ffh-foot-stack">
            {/* LOGO (same as header) */}
            <div className="logo">
              <Link className="navbar-brand" to="/">
                <img src="/images/logo_white.png" alt="Logo" />
              </Link>
            </div>
            <p>
              FutureFamilyAI is a product of HelixFoundry, Inc. Used by
              Surrogacy4All to support gestational surrogates and intended
              parents. Clinical and medical professional support is provided
              through Patients Medical, an independent professional practice.
            </p>
            <p>1148 5th Ave 1C, New York, NY 10128 · (212) 661-7673</p>
          </div>

          <div>
            <h4>Explore</h4>
            <ul>
              <li>
                <Link to="/how-it-works">How it works</Link>
              </li>
              <li>
                <Link to="/monitoring/blood-pressure-pregnancy">
                  Blood pressure
                </Link>
              </li>
              <li>
                <Link to="/family-planning/carrier-screening">
                  Carrier screening
                </Link>
              </li>
              <li>
                <Link to="/surrogacy/wellness-monitoring">Surrogacy</Link>
              </li>
              <li>
                <Link to="/postpartum/long-term-health">Postpartum</Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>For providers</h4>
            <ul>
              <li>
                <Link to="/providers">For physicians</Link>
              </li>
              <li>
                <Link to="/providers/emr-integration">EMR integration</Link>
              </li>
              <li>
                <Link to="/providers/clinical-protocol-acog-smfm">
                  Clinical protocol
                </Link>
              </li>
              <li>
                <Link to="/partners">For clinics &amp; agencies</Link>
              </li>
              <li>
                <Link to="/partners/directory">Partner directory</Link>
              </li>
              <li>
                <Link to="/partners/join-referral-network">
                  Join the network
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/about">About &amp; clinical team</Link>
              </li>
              <li>
                <Link to="/privacy-safety">Privacy &amp; safety</Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact</Link>
              </li>
              <li>
                <a href="https://www.surrogacy4all.com">Surrogacy4All</a>
              </li>
              <li>
                <a href="https://www.patientsmedical.com">Patients Medical</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="ffh-foot-legal">
          <p>
            FutureFamilyAI is a wellness and awareness tool. It is not a medical
            device, is not FDA-cleared, does not diagnose or treat any
            condition, and is not monitored in real time. It supports — and does
            not replace — your prenatal care. In an emergency, call 911.
          </p>
          <p>
            Patent pending. U.S. Patent Application Nos. 19/407,993, 19/750,760
            and 19/750,821. No patent has issued.
          </p>
          <p>
            Apple Watch and iPhone are trademarks of Apple Inc. Samsung and
            Galaxy Watch are trademarks of Samsung Electronics Co., Ltd.
            FutureFamilyAI is not affiliated with or endorsed by Apple or
            Samsung.
          </p>
          <p>
            <Link to="/privacy-safety">Privacy Policy</Link>
            {" · "}
            <Link to="/privacy-safety">Terms</Link>
            {" · © 2026 HelixFoundry, Inc."}
          </p>
        </div>
      </div>
    </footer>
  );
}